module.exports = __webpack_public_path__ + "static/media/mb_logo.752ca937.png";